import { LexicalEditor, LexicalNode, $applyNodeReplacement } from 'lexical';

import { ImagesGalleryNode } from './ImagesGalleryNode';

export function $createImagesGalleryNode(
  images: { name: string; id: string }[],
  editor: LexicalEditor,
  description?: string,
): ImagesGalleryNode {
  return $applyNodeReplacement(
    new ImagesGalleryNode(images, editor, description),
  );
}

export function $isImagesGalleryNode(
  node: LexicalNode | null | undefined,
): node is ImagesGalleryNode {
  return node instanceof ImagesGalleryNode;
}
